import { UppFloorPlanFurniture } from '../../floor-plan-element';
import type { FloorPlanAreaSourceDrawPieceItem, UppKonvaShape } from '../floor-plan-wire-types';
import { elementOptsFromLabels } from './shape-bridge-helpers';
import type { FloorPlanShapeBridge, SourceToWireInput } from './shape-bridge-types';

function adapterRowLabels(row: UppKonvaShape): {
  label?: string;
  sublabel?: string;
  zIndex?: number;
  custom?: unknown;
} {
  const o: { label?: string; sublabel?: string; zIndex?: number; custom?: unknown } = {};
  if ('label' in row && row.label !== undefined) {
    o.label = row.label;
  }
  if ('sublabel' in row && row.sublabel !== undefined) {
    o.sublabel = row.sublabel;
  }
  if ('zIndex' in row && row.zIndex !== undefined) {
    o.zIndex = row.zIndex;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'custom')) {
    o.custom = (row as { custom?: unknown }).custom;
  }
  return o;
}

export const genericShapeBridge: FloorPlanShapeBridge = {
  kind: 'GENERIC',
  wireType: 'GENERIC',
  sourceToWire(i: SourceToWireInput): UppKonvaShape {
    const fsRaw = String(i.d['shape'] ?? 'SQUARE').toUpperCase();
    const furnitureShape = fsRaw === 'ROUND' || fsRaw === 'CIRCLE' ? 'GENRND' : 'GENRCT';
    const p: FloorPlanAreaSourceDrawPieceItem = {
      type: 'GENERIC',
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height,
      rotation: i.rotation,
      furnitureShape,
      ...(i.id.uuid ? { uuid: i.id.uuid } : {}),
      ...i.lb,
    };
    return { ...p, ...(!i.id.uuid ? { id: i.id.id } : {}) } as UppKonvaShape;
  },
  wireToSource(row: UppKonvaShape) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const uuid = r.uuid !== undefined && r.uuid.trim() !== '' ? r.uuid.trim() : '';
    const legacyId = 'id' in row && typeof (row as { id?: unknown }).id === 'string' ? String((row as { id: string }).id) : '';
    const id = uuid || legacyId || 'shape-GENERIC';
    const base = {
      id,
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      rotation: r.rotation,
      ...adapterRowLabels(row),
    };
    const g = r.furnitureShape;
    const shape = g === 'GENRND' ? 'ROUND' : 'SQUARE';
    return {
      ...base,
      kind: 'GENERIC',
      data: { shape },
    };
  },
  wireToElement(row: UppKonvaShape, uuid: string) {
    const r = row as FloorPlanAreaSourceDrawPieceItem;
    const { x, y, width, height, rotation } = r;
    const opt = elementOptsFromLabels(r, false);
    const g = r.furnitureShape;
    const el = new UppFloorPlanFurniture(
      uuid,
      x,
      y,
      width,
      height,
      rotation,
      'generic',
      g === 'GENRND' ? 'GENRND' : 'GENRCT',
      opt,
    );
    el.zIndex = r.zIndex ?? 0;
    return el;
  },
};
